import { experiences } from './experiences';
import { traditions } from './traditions';

const slugify = (value) => value
  .toLowerCase()
  .replace(/&/g, ' and ')
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-|-$/g, '');

const placeLookup = new Map();

const addPlace = (place, relatedItem) => {
  if (!place?.name) return;
  const slug = place.slug || slugify(place.name);
  const current = placeLookup.get(slug) || {
    id: slug,
    slug,
    name: place.name,
    city: place.city || '',
    state: place.state || '',
    country: place.country || '',
    websiteUrl: place.websiteUrl || '',
    mapUrl: place.mapUrl || '',
    image: place.image || '',
    description: place.description || '',
    storySections: place.storySections || [],
    related: [],
  };

  ['city', 'state', 'country', 'websiteUrl', 'mapUrl', 'image', 'description', 'storySections'].forEach((key) => {
    if (!current[key] && place[key]) current[key] = place[key];
  });

  if (relatedItem && !current.related.some((item) => item.id === relatedItem.id)) {
    current.related.push(relatedItem);
  }
  placeLookup.set(slug, current);
};

traditions.forEach((tradition) => {
  const related = {
    id: `tradition-${tradition.id}`,
    title: tradition.name,
    eyebrow: 'Tradition',
    summary: tradition.summary,
    image: tradition.heroImage || '',
    route: tradition.archiveRouteName
      ? { name: tradition.archiveRouteName }
      : { name: 'reckon-way-tradition', params: { traditionSlug: tradition.slug } },
  };
  addPlace(tradition.defaultPlace, related);
  (tradition.locations || []).forEach((place) => addPlace(place, related));
  (tradition.occurrences || []).forEach((occurrence) => addPlace(occurrence.place, related));
});

experiences.forEach((experience) => {
  addPlace(experience.place, {
    id: `experience-${experience.id}`,
    title: experience.name,
    eyebrow: 'Experience',
    summary: experience.summary,
    image: experience.heroImage || '',
    route: { name: 'reckon-way-experience', params: { tagSlug: experience.slug } },
  });
});

export const places = [...placeLookup.values()]
  .map((place) => ({
    ...place,
    description: place.description || `A Reckon gathering place connected to ${place.related.map((item) => item.title).join(' and ')}.`,
  }))
  .sort((a, b) => a.name.localeCompare(b.name));

export const placesBySlug = places.reduce((lookup, place) => ({
  ...lookup,
  [place.slug]: place,
}), {});

export default places;
